import { SET_DASHBOARD_BASIC_DATA } from '../Actions/actionName'

const DashboardBasicDataReducer = (state = [], action) => {
  switch (action.type) {
    case SET_DASHBOARD_BASIC_DATA:
      return action.basicDatas;
    default:
      return state;
  }
};

export default DashboardBasicDataReducer;
